import { FC, ReactElement } from 'react'
import { Grid, GridCellProps, GridColumn, GridHeaderCellProps } from '@progress/kendo-react-grid'
import { StatusCheckActions, useAppDispatch, useAppSelector } from '../../stores'
import { useNavigate } from 'react-router-dom'
import { SupplierReply, ExpenseReplyCnt } from '@gateway.Home'
export interface ReplyStatusMatrixProps {
  // 業者回答状況
  supplierReplyList: SupplierReply[]
  // 業者回答状況テーブルデータ
  tableData: ExpenseReplyCnt[]
}

export const ReplyStatusMatrix: FC<ReplyStatusMatrixProps> = ({
  supplierReplyList,
  tableData
}) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const common = useAppSelector((x) => x.common)
  // 費目情報のリストを取得
  const expenses = common.initialData.codeNames('HI01')

  /**
   * 業者回答状況件数セル押下
   */
  const handleClickCell = (cellProps: GridCellProps) => {
    const expenseCode = cellProps.field ?? ''
    const branchCode = cellProps.dataItem.branchCd

    // 支店名列の場合は遷移しない
    if (expenseCode === 'branchNm') {
      return
    }

    let simulationYm = ''
    let replyStsCd = ''
    supplierReplyList.forEach((item) => {
      if (item.branchCd === branchCode && item.expenseCd === expenseCode) {
        simulationYm = item.simulationYm
        replyStsCd = item.replyStsCd
      }
    })
    let simulatedYear = ''
    let simulatedMonth = ''
    if (simulationYm !== '') {
      simulatedYear = simulationYm.substring(0, 4)
      simulatedMonth = simulationYm.substring(4, 6)
    } else {
      simulatedYear = new Date().getFullYear().toString()
      simulatedMonth = (new Date().getMonth() + 1).toString()
    }
    simulatedMonth =
    Number(simulatedMonth) > 9
      ? simulatedMonth
      : simulatedMonth.substring(1)

    dispatch(
      StatusCheckActions.setStatusCheckSearch({
        simulationY: simulatedYear,
        simulationM: simulatedMonth,
        branchCdList: [branchCode],
        expenseCd: expenseCode,
        supplierNm: '',
        replyStsCdList: [replyStsCd],
        sortOrder: '1',
        matrixTransitionFlg: true
      })
    )
    navigate('/supplier/status-check')
  }

  const cellRender = (
    _defaultRendering: ReactElement<HTMLTableCellElement> | null,
    cellProps: GridCellProps
  ) => {
    // 支店名列はカーソルを変更しない
    const cursorStyle = cellProps.field === 'branchNm' ? 'default' : 'pointer'
    return (
      <td
        style={{ cursor: cursorStyle }}
        aria-colindex={cellProps.columnIndex}
        role={'gridcell'}
        onClick={() => handleClickCell(cellProps)}
      >
        {cellProps.dataItem[cellProps.field ?? '']}
      </td>
    )
  }

  return (
    <>
      <h3>業者回答状況</h3>
      <Grid
        style={{ height: '250px' }}
        data={tableData}
        navigatable={true}
        selectedField="selected"
        cellRender={cellRender}
      >
        <GridColumn
          field="branchNm"
          title="支店"
          width="70px"
          editable={false}
        />
        {expenses.map((item) => (
          <GridColumn
            key={item.CODE}
            field={item.CODE}
            title={item.NAME}
            headerCell={(props: GridHeaderCellProps) => (
              <span
                title={props.title}
              >
                {props.title}
              </span>
            )}
          />
        ))}
      </Grid>
    </>
  )
}
